import { CardsFiltersParam } from '../../components/cards/interfaces/CardsFiltersParam';
import { CreatedInterfaces } from '../../interfaces';
import { useGetRequest } from './../utils/useGetRequest';

const parameterToParamMap = {
  cardholder: 'card_holder_id',
  ownershipLevel: 'ownership_level',
  cardholderParent: 'card_holder_parent_id',
  cardParent: 'card_id',
};

const resource = 'cards';

const useGetAllCards = (pageIndex: number, pageSize: number, cardsFilters: CardsFiltersParam) => {
  let path = `v2/cards?&size=${pageSize}&page=${pageIndex}`;

  Object.entries(cardsFilters).forEach(([param, value]) => {
    if (value && param in parameterToParamMap) {
      path += `&${parameterToParamMap[param]}=${value}`;
    }
  });

  const [{ data, error, loading }] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path,
  });

  return {
    cards: data?.data,
    pageInfo: {
      ...data?.meta,
      total: data?.meta?.total,
    },
    isLoading: loading,
    isError: error,
  };
};

export default useGetAllCards;
